import React, { useState } from 'react';
import { Info } from 'lucide-react';

// Small "i" icon that shows a short explanation on hover, keyboard focus or tap. Used to say which
// date range a dashboard section actually shows when it differs from the range picked in the header.
const InfoTip = ({ text, size = 14 }) => {
  const [open, setOpen] = useState(false);
  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: 6, verticalAlign: 'middle' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        aria-label={text}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((o) => !o)}
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'help', display: 'inline-flex', color: '#9CA3AF' }}
      >
        <Info size={size} />
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute', top: '100%', left: 0, marginTop: 6, zIndex: 50,
            width: 240, padding: '8px 10px', borderRadius: 8, fontSize: 12, lineHeight: 1.4, fontWeight: 400,
            background: '#111827', color: '#F9FAFB', boxShadow: '0 4px 16px rgba(0,0,0,0.3)', textAlign: 'left',
            whiteSpace: 'normal',
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoTip;
